import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "../styles/legal.css";
import logo from "../assets/PetfamLogo.png";
import { X } from "lucide-react";

export default function Terminos() {
  const navigate = useNavigate();
  const location = useLocation();

  // Sistema de animaciones de entrada
  const t = location.state?.transition;
  const screenUp = t === "screen" || t === "screen-up" || t === "up";
  const screenDown = t === "screen-down" || t === "down";

  const [enterClass, setEnterClass] = useState(
    screenDown ? "is-entering-down" : screenUp ? "is-entering" : ""
  );

  useEffect(() => {
    if (screenUp || screenDown) {
      const id = setTimeout(() => setEnterClass(""), 420);
      return () => clearTimeout(id);
    }
  }, [screenUp, screenDown]);

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  const lastUpdated = "7 de noviembre de 2025";

  return (
    <div className={`legal-shell ${enterClass}`}>
    
      {/* X para volver */}
      <button
        className="close-btn"
        onClick={() => navigate("/")}
        aria-label="Volver al inicio"
        title="Volver al inicio"
      >
        <X />
      </button>

      {/* header */}
      <header className="legal-header">
        <div className="legal-header-inner">
          <Link to="/" className="legal-logo" aria-label="Ir al inicio">
            <img src={logo} alt="Petfam logo" />
          </Link>
          <Link to="/crear-cuenta" className="legal-cta">
            Suscribirse
          </Link>
        </div>
      </header>

      {/* 2️⃣ contenido que hace el “pop” de entrada */}
      <main className="legal-main" role="main">
        <section className="legal-hero">
          <h1 className="legal-title">Política de privacidad y tratamiento de datos</h1>
          <p className="legal-updated">Última actualización: {lastUpdated}</p>

          <div className="legal-content">
            <p>
              <strong>PETFAM</strong>, una marca operada por
              <strong> Vetia Group S.A.S.</strong>, reconoce la importancia de la privacidad de los
                datos personales y se compromete a proteger la información de sus usuarios conforme a la Ley 1581
                de 2012 y demás normas aplicables de protección de datos en Colombia.
            </p>

            <h3>1. Responsable del tratamiento</h3>
            <p>
              Vetia Group S.A.S<br />
              Correo: <a href="mailto:soporte@petfam.club" className="legal-link">soporte@petfam.club</a><br />
              Dirección: Cra 9 norte # 2N 39, Popayán, Colombia
              Línea móvil: +57 3168756765
            </p>

            <h3>2. Datos recolectados</h3>
            <p>
              PETFAM recolecta información personal necesaria para la prestación del servicio, que puede incluir:<br />
                - Datos de identificación del usuario (nombre, correo, teléfono).<br />
                - Datos de la mascota (nombre, especie, edad, características).<br />
                - Información de pago (manejada exclusivamente por la pasarela de pagos).<br />
                - Datos de uso dentro de la app y registros de atención veterinaria.
            </p>

            <h3>3. Finalidades del tratamiento</h3>
            <p>
              Los datos se utilizan para:<br />
                - Registrar y gestionar las cuentas de usuario.<br />
                - Facilitar las consultas virtuales con veterinarios o etólogos.<br />
                - Mantener la historia clínica y calendario de actividades.<br />
                - Facturar y cobrar los servicios suscritos.<br />
                - Mejorar la experiencia del usuario y realizar seguimiento de calidad.<br />
                - Cumplir con obligaciones legales y contractuales.
            </p>

            <h3>4. Derechos del titular</h3>
            <p>
              Los usuarios pueden:<br />
                - Conocer, actualizar o rectificar sus datos.<br />
                - Solicitar la eliminación de sus datos cuando sea procedente.<br />
                - Revocar la autorización de uso.<br />
                - Acceder gratuitamente a la información registrada.<br />
              Las solicitudes pueden enviarse al correo <a href="mailto:soporte@petfam.co" className="legal-link">soporte@petfam.club</a>
            </p>

            <h3>5. Medidas de seguridad</h3>
            <p>
              PETFAM implementa medidas técnicas, humanas y administrativas razonables para proteger los datos
              personales contra acceso no autorizado, pérdida o alteración.
            </p>

            <h3>6. Transferencia de datos a terceros</h3>
            <p>
              La información podrá ser compartida únicamente con:<br />
                - Profesionales veterinarios o etólogos adscritos a PETFAM, para la prestación del servicio.<br />
                - Proveedores tecnológicos (por ejemplo, pasarela de pagos o servidores en la nube).<br />
                - Autoridades competentes cuando sea legalmente requerido.<br />
            </p>

            <h3>7. Conservación</h3>
            <p>
              Los datos se conservarán durante el tiempo necesario para cumplir las finalidades descritas o según
              las exigencias legales aplicables.
            </p>

            <div className="legal-footnote">
              PETFAM podrá actualizar estas políticas cuando sea necesario. Revise
              periódicamente esta página para conocer la versión vigente.
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
